import api from './api';

export type StripeMode = 'live' | 'test';

export interface StripeAccountInfo {
  id: string;
  business_name: string | null;
  email: string | null;
}

export interface StripeStatus {
  connected: boolean;
  active: boolean;
  mode?: StripeMode;
  account?: StripeAccountInfo | null;
  error?: string;
}

export interface SaveStripeResult extends StripeStatus {
  saved: boolean;
}

export const getStripeStatus = async (comercioKey: string): Promise<StripeStatus> => {
  const { data } = await api.get(`/comercios/${encodeURIComponent(comercioKey)}/pagos-config/stripe/status`);
  return data;
};

export const saveStripeSecret = async (comercioKey: string, secretKey: string): Promise<SaveStripeResult> => {
  const { data } = await api.post(`/comercios/${encodeURIComponent(comercioKey)}/pagos-config/stripe/save`, {
    secretKey,
  });
  return data;
};

export const toggleStripeActive = async (comercioKey: string, active: boolean): Promise<{ success: boolean; active: boolean }> => {
  const { data } = await api.post(`/comercios/${encodeURIComponent(comercioKey)}/pagos-config/stripe/toggle`, { active });
  return data;
};

export const clearStripeSecret = async (comercioKey: string): Promise<{ cleared: boolean; connected: false; active: false }> => {
  const { data } = await api.delete(`/comercios/${encodeURIComponent(comercioKey)}/pagos-config/stripe/clear`);
  return data;
};